import React from 'react';

import { QualityLabel, TextContainer, TextWrapper, WidgetContainer } from './data-quality-chart.styled';
import { DataQualityChartProps } from './data-quality-chart.types';
import { Text } from 'common/common-components.styled';
import { EmptyDataIcon } from 'components/icons-new/empty-data';

import { useDataQualityChart } from './use-data-quality-chart';
import { EmptyDataContainer, ChartContainer } from './data-quality-chart.styled';
import DoughnutChart from './doughnut-chart';

const DataQualityChart = ({ dataQuality }: DataQualityChartProps) => {
  const { qualities, amounHandleClick, selectedIndex, hoverIndex, handleChangeSelectedIndex, handleChangeHoverIndex } =
    useDataQualityChart(dataQuality);

  if (qualities.length === 0 || !dataQuality) {
    return (
      <WidgetContainer>
        <EmptyDataContainer>
          <EmptyDataIcon hovered />
          <span>Es gibt keine Daten</span>
        </EmptyDataContainer>
      </WidgetContainer>
    );
  }

  const activeIndex = hoverIndex !== null ? hoverIndex : selectedIndex;
  const activeSegment = qualities[activeIndex];

  return (
    <WidgetContainer>
      <ChartContainer>
        <DoughnutChart
          hoverIndex={hoverIndex}
          selectedIndex={selectedIndex}
          segments={qualities}
          onChangeSelectedIndex={handleChangeSelectedIndex}
          onChangeHoverIndex={handleChangeHoverIndex}
        />
      </ChartContainer>
      <TextContainer>
        <TextWrapper onClick={() => amounHandleClick(activeSegment.filterValue)}>
          <Text size='24' color='blue' bold>
            {activeSegment.value}
          </Text>
          <QualityLabel indicatorColor={activeSegment.color}>{activeSegment.label}</QualityLabel>
        </TextWrapper>
      </TextContainer>
    </WidgetContainer>
  );
};

export default DataQualityChart;
